<template>
  <div>
    <div>
      <h2 v-if="id">
        Edit group: {{ group.name }}
      </h2>
      <h2 v-else>
        Create a group
      </h2>
    </div>
    <bootstrap-form
      v-model="group"
      :fields="fields"
      :url="`groups/${id ? id + '/' : ''}`"
      :method="id ? 'PATCH' : 'POST'"
      cancelable
      @submit="submitForm"
      @cancel="$router.go(-1)"
    />
  </div>
</template>

<script>
import BootstrapForm from '../../components/BootstrapForm.vue';

export default {
  name: 'AddGroup',
  components: {
    BootstrapForm,
  },
  data() {
    return {
      fields: [
        {
          name: 'name',
          placeholder: 'Type group name here',
          required: true,
        },
        {
          name: 'short_description',
          type: 'textarea',
          placeholder: 'Type a short description here',
          maxlength: 255,
          rows: 2,
          required: true,
        },
        {
          name: 'cover',
          label: 'Cover',
          type: 'image',
          ratio: 2 / 1,
        },
        {
          name: 'icon',
          label: 'Icon',
          type: 'image',
          ratio: 1,
        },
      ],
      group: {
        id: null,
        name: '',
        short_description: '',
        cover: '',
        logo: '',
      },
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    userData() {
      return this.$store.state.userData;
    },
    categories() {
      return this.$store.state.categories.results;
    },
  },
  async mounted() {
    if (this.id) {
      const response = await this.api({ url: `groups/${this.id}` });
      if (response.ok) {
        this.group = response.body;
      }
    }
  },
  methods: {
    async submitForm(id) {
      this.$store.dispatch('fetchUserGroups');
      this.$router.push({ name: 'group_detail', params: { id } });
    },
  },
};
</script>

<style lang="scss" scoped>
  input[type="file"] {
    display: none;
  }

  .image-preview {
    margin: 5px;
    width: 75px;
    height: 75px;
    border-radius: 10px;
  }
</style>
